import { createFileRoute } from "@tanstack/react-router";

// `validateSearch` stays in this eager file so the router can parse URL
// params before deciding which chunk to load. The component lives in
// `verify.lazy.tsx`.
export const Route = createFileRoute("/login/verify")({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === "string" ? search.token : "",
  }),
});
